<template>
	<div class="share">
		<van-share-sheet v-model:show="showSheet" title="立即分享" :options="shareOptions" @select="onSelectShare" @cancel="closeShareSheet" @click-overlay="closeShareSheet"  :style="{bottom:botmLen+'px'}"/>

		<van-popup v-model="showShareQRCode" position="bottom" :style="{ 'max-height': '80%' ,'text-align':'center',bottom:botmLen+'px'}">
			<van-cell-group title="扫描二维码" class="pay_type_group">
				<vue-qr :text="shareUrl" :size="220" ref="Qrcode"></vue-qr>
				<van-button type="primary" block @click="showShareQRCode=false" >已分享</van-button>
			</van-cell-group>
		</van-popup>
	</div>
</template>

<script type="text/ecmascript-6">
import { chkWeiXin } from "@/utils/common.js";
import {ShareSheet} from "vant";
import {wxShareUtil} from "@/utils/wxShareUtil.js";
import vueQr from "vue-qr";

export default {
	name: "share",
	components: {
		"van-share-sheet":ShareSheet,
		"vue-qr":vueQr
	},
	data() {
		return {
			title: "",
			wxShareObj:null,
			showSheet:true,
			shareOptions: [],
			showShareQRCode:false,
			botmLen:0
		};
	},
	props:{
		showShareSheet:Boolean,
		shareUrl:String,
		shareConfig:Object,
		botm:Number
	},
	mounted() {
	},
	created() {
		this.botmLen = this.botm?this.botm:0;
		this.wxShareObj = new wxShareUtil();
		this.shareOptions = this.wxShareObj.shareOptions();
		this.wxShareObj.init(this.shareUrl,this.shareConfig);
	},
	methods: {
		onSelectShare(o){
			let that = this;
			if(o.icon=='link'){
				that.$copyText(that.shareUrl).then(function (e) {
					that.$toast.success("复制成功,去分享吧！");
					that.closeShareSheet();
				}, function (e) {
					that.$toast.fail("复制失败,请稍候重试！");
				});
			}else if(o.icon == 'qrcode'){
				that.showShareQRCode = true;
				console.log(that.shareUrl)
			}else {
				that.wxShareObj.shareAction();
				that.closeShareSheet();
			}
		},
		closeShareSheet(){
			this.showSheet = false;
			this.$emit('update:showShareSheet',false);
		},
		resetInit(){
			this.wxShareObj.initWxConfig();
		}
	},
	computed:{
	},
	filters:{
	}
};
</script>




// WEBPACK FOOTER //
// src/components/Commom/Share.vue